module.exports = "<page-title> {{title}} <page-title-pill *ngFor=\"let pill of pills\" icon={{pill.icon}}>{{pill.label}}</page-title-pill> </page-title> ";